import { createType } from 'framework/utils/createType';

export const SupplierAccountDetailTabTypes = createType('purchases', 'payments');
export type SupplierAccountDetailTabType = typeof SupplierAccountDetailTabTypes[number];
